import { BindAll } from 'lodash-decorators'
import { MySettingsNoticeController } from './settings-notice'
import { MySettingsAccountController } from './settings-account'

@BindAll()
export class MySettingsController {
  /**
   * 通知设置
   */
  Notice = new MySettingsNoticeController()
  /**
   * 账号设置
   */
  Account = new MySettingsAccountController()
}
